// https://data.census.gov/table/DECENNIALDDHCA2020.T01001?t=3981:402:4038&tp=true
// https://www.nih.gov/nih-style-guide/race-national-origin
// https://www.census.gov/library/stories/2021/08/improved-race-ethnicity-measures-reveal-united-states-population-much-more-multiracial.html
// https://www.prb.org/articles/race-ethnicity-categories-in-federal-surveys-are-changing-implications-for-data-users/

export default {
    "config": {
        "White": {
            "weight": 0.61,
            "hispanic_weight": 0.148,
            "eligible_suffixes": [
                "with Mexican ethnicity",
                "with Central American heritage",
                "with Costa Rican ethnicity",
                "with Guatemalan ethnicity",
                "with Honduran ethnicity",
                "with Nicaraguan ethnicity",
                "with Panamanian ethnicity",
                "with Salvadoran ethnicity",
                "with South American heritage",
                "with Argentinean ethnicity",
                "with Bolivian ethnicity",
                "with Chilean ethnicity",
                "with Colombian ethnicity",
                "with Ecuadorian ethnicity",
                "with Paraguayan ethnicity",
                "with Peruvian ethnicity",
                "with Uruguayan ethnicity",
                "with Venezuelan ethnicity",
                "with Caribbean heritage",
                "with Cuban ethnicity",
                "with Dominican ethnicity",
                "with Puerto Rican ethnicity",
                "and Spaniard",
                "with Spanish heritage",
                "and Hispanic",
                "and Latino(a)"
            ],
            "disallowed_combos": [
                "White: Spanish and Hispanic",
                "White: Spanish and Spaniard",
                "White: Spanish with Spanish heritage"
            ]
        },
        "Black or African American": {
            "weight": 0.17,
            "white_prefix_weight": 0.176,
            "hispanic_weight": 0.176,
            "eligible_suffixes": [
                "with Caribbean heritage",
                "with Cuban ethnicity",
                "with Dominican ethnicity",
                "with Puerto Rican ethnicity",
                "and Hispanic",
                "and Latino(a)",
                "with South American heritage",
                "with Central American heritage",
                "with Colombian ethnicity",
                "with Venezuelan ethnicity"
            ],
            "disallowed_combos": [
                "Black: Somali with Cuban ethnicity",
                "Black: Beninese with Puerto Rican ethnicity",
                "Black: Angolan and Hispanic",
                "Black: Tanzanian with Salvadoran ethnicity",
                "Black: Sudanese with Dominican ethnicity",
                "Black: Mozambican with Cuban ethnicity",
                "Black: Swazi with Venezuelan ethnicity",
                "Black: Eritrean with Colombian ethnicity",
                "Black: Burundian with Central American heritage"
            ]
        },
        "Asian": {
            "weight": 0.085,
            "white_prefix_weight": 0.235,
            "black_prefix_weight": 0.058
        },
        "Middle Eastern or North African": {
            "weight": 0.01
        },
        "Native American or Alaska Native": {
            "weight": 0.042,
            "white_prefix_weight": 0.476,
            "black_prefix_weight": 0.119,
            "hispanic_weight": 0.119,
            "eligible_suffixes": [
                "and Hispanic"
            ]
        },
        "Native Hawaiian or Pacific Islander": {
            "weight": 0.002
        },
        "Some Other Race": {
            "weight": 0.001
        },
        "Hispanic or Latino": {
            "weight": 0.08
        }
    },
    "categories": {
        "White": {
            "White": 105000000,
            "White: Albanian": 198937,
            "White: Alsatian": 2328,
            "White: Andorran": 155,
            "White: Armenian": 360166,
            "White: Austrian": 129632,
            "White: Azerbaijani": 10321,
            "White: Basque": 18270,
            "White: Belarusian": 49545,
            "White: Belgian": 101759,
            "White: Bosnian and Herzegovinian": 112441,
            "White: British": 195544,
            "White: British Islander": 18661,
            "White: Bulgarian": 76316,
            "White: Carpatho Rusyn": 3842,
            "White: Celtic": 13013,
            "White: Cornish": 1061,
            "White: Croatian": 140584,
            "White: Cypriot": 5889,
            "White: Czech": 325610,
            "White: Danish": 285913,
            "White: Dutch": 898681,
            "White: English": 25536410,
            "White: Estonian": 12578,
            "White: Faroe Islander": 93,
            "White: Finnish": 202568,
            "White: French": 1536256,
            "White: Frisian": 807,
            "White: Georgian": 21863,
            "White: German": 15447670,
            "White: Greek": 577443,
            "White: Hungarian": 363087,
            "White: Icelandic": 17061,
            "White: Irish": 10909541,
            "White: Italian": 6629993,
            "White: Kosovan": 4719,
            "White: Lapp": 629,
            "White: Latvian": 35853,
            "White: Liechtensteiner": 314,
            "White: Lithuanian": 174487,
            "White: Luxembourger": 11386,
            "White: Macedonian": 33957,
            "White: Maltese": 16162,
            "White: Manx": 1761,
            "White: Moldovan": 31458,
            "White: Monegasque": 163,
            "White: Montenegrin": 9906,
            "White: Northern Irelander": 1611,
            "White: Norwegian": 1030462,
            "White: Polish": 2686362,
            "White: Portuguese": 601974,
            "White: Roma": 5369,
            "White: Romanian": 216096,
            "White: Russian": 984177,
            "White: Scandinavian": 420514,
            "White: Scots-Irish": 356869,
            "White: Scottish": 1471817,
            "White: Serbian": 106222,
            "White: Slavic": 67728,
            "White: Slovak": 189081,
            "White: Slovenian": 53691,
            "White: Swedish": 787829,
            "White: Swiss": 195119,
            "White: Tatar": 2895,
            "White: Turkish": 177555,
            "White: Ukrainian": 476106,
            "White: Welsh": 276199,
            "White: Afrikaner": 1016,
            "White: Australian": 66158,
            "White: Cajun": 82330,
            "White: Canadian": 255012,
            "White: French Canadian": 255555,
            "White: Greenlandic": 103,
            "White: New Zealander": 13527,
            "White: Pennsylvania German": 86856
        },
        "Black or African American": {
            "African American": 22091770,
            "Black: Angolan": 5487,
            "Black: Beninese": 5472,
            "Black: Bisseau-Guinean": 548,
            "Black: Burkinabe": 7011,
            "Black: Burundian": 9265,
            "Black: Cameroonian": 56562,
            "Black: Central African": 1695,
            "Black: Chadian": 1561,
            "Black: Congolese": 87067,
            "Black: Djiboutian": 1303,
            "Black: Equatorial Guinean": 670,
            "Black: Eritrean": 64025,
            "Black: Ethiopian": 300108,
            "Black: Gabonese": 1930,
            "Black: Gambian": 13361,
            "Black: Ghanaian": 150442,
            "Black: Guinean": 14346,
            "Black: Ivoirian": 17009,
            "Black: Kenyan": 91348,
            "Black: Liberian": 61349,
            "Black: Malagasy": 2244,
            "Black: Malawian": 2789,
            "Black: Malian": 7402,
            "Black: Motswana": 1005,
            "Black: Mozambican": 834,
            "Black: Namibian": 768,
            "Black: Nigeria": 493188,
            "Black: Rwandan": 12426,
            "Black: Senegalese": 21063,
            "Black: Sierra Leonean": 27575,
            "Black: Somali": 209896,
            "Black: South African": 13889,
            "Black: South Sudanese": 12428,
            "Black: Sudanese": 56147,
            "Black: Swazi": 1004,
            "Black: Tanzanian": 12174,
            "Black: Togolese": 18562,
            "Black: Ugandan": 22889,
            "Black: Zambian": 6205,
            "Black: Zimbabwean": 12576,
            "Black: Anguillan": 570,
            "Black: Antiguan/Barbudan": 13402,
            "Black: Bahamian": 25006,
            "Black: Barbadian": 36142,
            "Black: British Virgin Islander": 573,
            "Black: Dominica Islander": 5952,
            "Black: Grenadian": 20327,
            "Black: Haitian": 916277,
            "Black: Jamaican": 811245,
            "Black: Kittian/Nevisian": 6038,
            "Black: Montserratian": 1515,
            "Black: St. Lucian": 15366,
            "Black: Trinidadian/Tobagonian": 131109,
            "Black: U.S. Virgin Islander": 11670,
            "Black: Vincentian": 11211,
            "Black: West Indian": 74964
        },
        "Asian": {
            "Asian: Chinese": 4128718,
            "Asian: Hmong": 315707,
            "Asian: Japanese": 741544,
            "Asian: Korean": 1508575,
            "Asian: Mongolian": 28383,
            "Asian: Taiwanese": 259317,
            "Asian: Afghan": 129949,
            "Asian: Kazakh": 12877,
            "Asian: Kyrgyz": 7036,
            "Asian: Tajik": 3507,
            "Asian: Turkmen": 1452,
            "Asian: Uzbek": 30716,
            "Asian: Indian": 4397737,
            "Asian: Bangladeshi": 256519,
            "Asian: Bhutanese": 39565,
            "Asian: Maldivian": 151,
            "Asian: Nepalese": 205297,
            "Asian: Pakistani": 618037,
            "Asian: Sikh": 48321,
            "Asian: Sindhi": 185,
            "Asian: Sri Lankan": 69694,
            "Asian: Bruneian": 107,
            "Asian: Burmese": 258595,
            "Asian: Cambodian": 280364,
            "Asian: Filipino": 3076108,
            "Asian: Indonesian": 85118,
            "Asian: Laotian": 188906,
            "Asian: Malaysian": 25429,
            "Asian: Mien": 17915,
            "Asian: Singaporean": 8131,
            "Asian: Thai": 201377,
            "Asian: Vietnamese": 1951746,
            "Asian: Buryat": 560,
            "Asian: Kalmyk": 553,
            "Asian: Kuki": 62,
            "Asian: Lahu": 1954,
            "Asian: Malay": 1639,
            "Asian: Mizo": 300,
            "Asian: Pashtun": 364,
            "Asian: Tai Dam": 1361,
            "Asian: Timorese": 67
        },
        "Middle Eastern or North African": {
            "Middle Eastern: Arab": 170437,
            "Middle Eastern: Assyrian": 42372,
            "Middle Eastern: Bahraini": 673,
            "Middle Eastern: Chaldean": 47029,
            "Middle Eastern: Emirati": 1931,
            "Middle Eastern: Iranian": 413842,
            "Middle Eastern: Iraqi": 179252,
            "Middle Eastern: Israeli": 137023,
            "Middle Eastern: Jordanian": 102919,
            "Middle Eastern: Kurdish": 19755,
            "Middle Eastern: Kuwaiti": 5204,
            "Middle Eastern: Lebanese": 328137,
            "Middle Eastern: Omani": 868,
            "Middle Eastern: Palestinian": 132935,
            "Middle Eastern: Qatari": 452,
            "Middle Eastern: Saudi": 22404,
            "Middle Eastern: Syriac": 1670,
            "Middle Eastern: Syrian": 122194,
            "Middle Eastern: Yazidi": 444,
            "Middle Eastern: Yemeni": 73692,
            "North African: Algerian": 30439,
            "North African: Berber": 1750,
            "North African: Egyptian": 313720,
            "North African: Libyan": 10895,
            "North African: Moroccan": 98838,
            "North African: Tunisian": 10667
        },
        "Native American or Alaska Native": {
            "Native American": 1862511,
            // "Native American": 316396,
            // "Native American (Absentee Shawnee Tribe of Indians of Oklahoma)": 2050,
            // "Native American (Apache)": 36492,
            // "Native American (Assiniboine)": 2278,
            // "Native American (Assiniboine and Sioux Tribes of the Fort Peck Indian Reservation, Montana)": 5336,
            // "Native American (Bad River Band of the Lake Superior Tribe)": 2418,
            // "Native American (Blackfeet Tribe of the Blackfeet Indian Reservation of Montana)": 34810,
            // "Native American (Catawba Indian Nation)": 2236,
            // "Native American (Cherokee)": 214940,
            // "Native American (Cherokee Nation)": 31432,
            // "Native American (Cheyenne)": 3382,
            // "Native American (Cheyenne and Arapaho Tribes, Oklahoma)": 5017,
            // "Native American (Cheyenne River Sioux Tribe of the Cheyenne River Reservation, South Dakota)": 10064,
            // "Native American (The Chickasaw Nation)": 29436,
            // "Native American (Chippewa)": 39057,
            // "Native American (Chippewa Cree Indians of the Rocky Boy's Reservation, Montana)": 5597,
            // "Native American (Choctaw)": 69454,
            // "Native American (Choctaw-Apache Community of Ebarb)": 2567,
            // "Native American (The Choctaw Nation of Oklahoma)": 25088,
            // "Native American (Chumash)": 4671,
            // "Native American (Citizen Potawatomi Nation, Oklahoma)": 3640,
            // "Native American (Colorado River Indian Tribe)": 2635,
            // "Native American (Comanche Nation, Oklahoma)": 12388,
            // "Native American (Confederated Salish and Kootenai Tribes of the Flathead Nation)": 4640,
            // "Native American (Confederated Tribes and Bands of the Yakama Nation)": 8396,
            // "Native American (Confederated Tribes of Siletz Indians of Oregon)": 2529,
            // "Native American (Confederated Tribes of the Colville Reservation)": 7520,
            // "Native American (Confederated Tribes of the Grand Ronde Community of Oregon)": 2670,
            // "Native American (Confederated Tribes of Warm Springs)": 3458,
            // "Native American (Costanoan)": 2138,
            // "Native American (Cowlitz Indian Tribe)": 2506,
            // "Native American (Cree)": 2059,
            // "Native American (Crow Creek Sioux Tribe of the Crow Creek Reservation, South Dakota)": 2442,
            // "Native American (Crow Tribe of Montana)": 11014,
            // "Native American (Delaware (Lenni-Lenape))": 4461,
            // "Native American (Eastern Band of Cherokee Indians)": 8075,
            // "Native American (Eastern Shoshone Tribe of the Wind River Reservation, Wyoming)": 2323,
            // "Native American (Echota Cherokee Tribe of Alabama)": 2919,
            // "Native American (Gabrieleno)": 2014,
            // "Native American (Gila River Indian Community of the Gila River Indian Reservation)": 13697,
            // "Native American (Gros Ventres)": 2374,
            // "Native American (Haliwa-Saponi Indian Tribe)": 3091,
            // "Native American (Ho-Chunk Nation)": 5364,
            // "Native American (Hoopa Valley Tribe)": 2964,
            // "Native American (Hopi Tribe of Arizona)": 12412,
            // "Native American (Jicarilla Apache Nation)": 3627,
            // "Native American (Juaneno (Acjachemem))": 2115,
            // "Native American (Karuk Tribe)": 3427,
            // "Native American (Kewa Pueblo, New Mexico)": 3734,
            // "Native American (Kickapoo)": 2940,
            // "Native American (Kiowa)": 4268,
            // "Native American (Kiowa Indian Tribe of Oklahoma)": 2549,
            // "Native American (Klamath Tribes)": 3015,
            // "Native American (Lac Courte Oreilles Band of Lake Superior Chippewa)": 2840,
            // "Native American (Leech Lake Band)": 4197,
            // "Native American (Lipan Apache)": 2126,
            // "Native American (Lower Brule Sioux Tribe of the Lower Brule Reservation, South Dakota)": 2090,
            // "Native American (Lumbee Tribe of North Carolina)": 54293,
            // "Native American (Lummi Tribe)": 3687,
            // "Native American (Makah Indian Tribe)": 2278,
            // "Native American (Menominee Indian Tribe)": 8389,
            // "Native American (Mescalero Apache Tribe of the Mescalero Reservation, New Mexico)": 6348,
            // "Native American (Miami)": 2123,
            // "Native American (Micmac)": 2577,
            // "Native American (Mille Lacs Band)": 2210,
            // "Native American (Mississippi Band of Choctaw Indians)": 7306,
            // "Native American (Miwok/Me-Wuk)": 2577,
            // "Native American (Mohawk)": 8522,
            // "Native American (MOWA Band of Choctaw Indians)": 2332,
            // "Native American (Muckleshoot Indian Tribe)": 2181,
            // "Native American (The Muscogee (Creek) Nation)": 40677,
            // "Native American (Navajo Nation)": 315086,
            // "Native American (Nez Perce Tribe)": 3438,
            // "Native American (Northern Arapaho Tribe)": 5075,
            // "Native American (Northern Cheyenne Tribe of the Northern Cheyenne Reservation, Montana)": 6009,
            // "Native American (Oglala Sioux Tribe)": 25212,
            // "Native American (Omaha Tribe of Nebraska)": 4498,
            // "Native American (Oneida)": 5740,
            // "Native American (Oneida Nation)": 6688,
            // "Native American (The Osage Nation)": 8250,
            // "Native American (Otoe-Missouria Tribe of Indians)": 2022,
            // "Native American (Ottawa)": 3219,
            // "Native American (Paiute)": 4230,
            // "Native American (Pascua Yaqui Tribe of Arizona)": 10703,
            // "Native American (Passamaquoddy Tribe)": 2088,
            // "Native American (Pawnee)": 2243,
            // "Native American (Pima)": 4234,
            // "Native American (Poarch Band of Creeks)": 3215,
            // "Native American (Pomo)": 2902,
            // "Native American (Potawatomi)": 11358,
            // "Native American (Pueblo)": 4340,
            // "Native American (Pueblo of Acoma)": 4595,
            // "Native American (Pueblo of Isleta)": 4326,
            // "Native American (Pueblo of Jemez)": 2922,
            // "Native American (Pueblo of Laguna)": 6467,
            // "Native American (Pueblo of San Felipe)": 3116,
            // "Native American (Pueblo of Taos)": 2151,
            // "Native American (Puyallup Tribe of The Puyallup Reservation)": 3054,
            // "Native American (Quechan Tribe of the Fort Yuma Indian Reservation, California and Arizona)": 2630,
            // "Native American (Quinault Indian Nation)": 2629,
            // "Native American (Red Lake Band of Chippewa Indians)": 6572,
            // "Native American (Rosebud Sioux Tribe of the Rosebud Indian Reservation, South Dakota)": 15319,
            // "Native American (Saginaw Chippewa Indian Tribe)": 2122,
            // "Native American (Saint Regis Mohawk Tribe)": 3047,
            // "Native American (Salt River Pima-Maricopa Indian Community)": 5573,
            // "Native American (San Carlos Apache Tribe of the San Carlos Reservation)": 8602,
            // "Native American (Sault Ste. Marie Tribe of Chippewa Indians)": 8415,
            // "Native American (Seminole)": 7189,
            // "Native American (The Seminole Nation of Oklahoma)": 3524,
            // "Native American (Seneca Nation of Indians)": 6412,
            // "Native American (Shawnee)": 2162,
            // "Native American (Shoshone)": 4090,
            // "Native American (Shoshone-Bannock Tribes of the Fort Hall Reservation)": 4512,
            // "Native American (Sioux)": 30408,
            // "Native American (Sisseton-Wahpeton Oyate of the Lake Traverse Reservation, South Dakota)": 5765,
            // "Native American (Spirit Lake Tribe)": 3937,
            // "Native American (Spokane Tribe of the Spokane Reservation)": 2767,
            // "Native American (Standing Rock Sioux Tribe of North and South Dakota)": 8200,
            // "Native American (Three Affiliated Tribes of the Ft. Berthold Reservation, North Dakota)": 6205,
            // "Native American (Tohono O'odham Nation of Arizona)": 19451,
            // "Native American (Tulalip Tribes of Washington)": 3053,
            // "Native American (Turtle Mountain Band of Chippewa Indians of North Dakota)": 13046,
            // "Native American (Tuscarora Nation)": 2268,
            // "Native American (United Houma Nation)": 7817,
            // "Native American (Ute)": 4507,
            // "Native American (White Earth Band)": 4635,
            // "Native American (White Mountain Apache Tribe of the Fort Apache Reservation, Arizona)": 15429,
            // "Native American (Wyandotte Nation)": 2376,
            // "Native American (Yankton Sioux Tribe of South Dakota)": 4996,
            // "Native American (Yaqui)": 17048,
            // "Native American (Ysleta del Sur Pueblo of Texas)": 3440,
            // "Native American (Yurok Tribe)": 4564,
            // "Native American (Zuni Tribe of the Zuni Reservation)": 9742,
            "Alaska Native": 66209,
            // "Alaska Native": 28044,
            // "Alaska Native (Alaskan Athabascan)": 4893,
            // "Alaska Native (Aleut)": 4878,
            // "Alaska Native (Eskimo)": 3337,
            // "Alaska Native (Inupiat/Inupiaq)": 5674,
            // "Alaska Native (Native Village of Barrow Inupiat Traditional Government)": 2565,
            // "Alaska Native (Tlingit)": 7792,
            // "Alaska Native (Yup'ik Eskimo)": 9026,
            "Canadian Indian": 3500,
            "French Canadian/French American Indian": 3500,
            "Dominican Indian": 1203,
            "Puerto Rican Indian": 2373,
            "Caribbean Indian": 31726,
            // "Caribbean Indian": 3380,
            // "Caribbean Indian (Taino)": 28346,
            "Central American Indian": 2543,
            "Salvadoran Indian": 8299,
            "Guatemalan Indian": 7108,
            "Honduran Indian": 3452,
            "Maya Central American": 18942,
            "Maya": 180359,
            "Mexican American Indian": 11007,
            "Mexican Indian": 34113,
            // "Mexican Indian": 15235,
            "Mexican Indian (Aztec)": 387122,
            // "Mexican Indian (Tarasco/Purepecha)": 10785,
            // "Mexican Indian (Zapotec)": 8093,
            "South American Indian": 20756,
            // "South American Indian": 3005,
            // "South American Indian (Ecuadorian Indian)": 2416,
            // "South American Indian (Inca)": 13305,
            // "South American Indian (Quechua)": 2030,
            "Guyanese South American Indian": 3874,
            "Spanish American Indian": 5734
        },
        "Native Hawaiian or Pacific Islander": {
            "Native Hawaiian": 284000,
            "Pacific Islander: Cook Islander": 100,
            "Pacific Islander: Easter Islander": 55,
            "Pacific Islander: French Polynesian": 207,
            "Pacific Islander: Maori": 1034,
            "Pacific Islander: Niuean": 126,
            "Pacific Islander: Rotuman": 81,
            "Pacific Islander: Samoan": 133148,
            "Pacific Islander: Tahitian": 882,
            "Pacific Islander: Tongan": 48536,
            "Pacific Islander: Tokelauan": 44,
            "Pacific Islander: Tuvaluan": 132,
            "Pacific Islander: Wallisian and Futunan": 8,
            "Pacific Islander: Carolinian": 531,
            "Pacific Islander: Chamorro": 70704,
            "Pacific Islander: Chuukese": 10500,
            "Pacific Islander: Guamanian": 10583,
            "Pacific Islander: I-Kiribati": 291,
            "Pacific Islander: Kosraean": 1644,
            "Pacific Islander: Marshallese": 47300,
            "Pacific Islander: Nauruan": 23,
            "Pacific Islander: Northern Mariana Islander": 247,
            "Pacific Islander: Palauan": 7431,
            "Pacific Islander: Pohnpeian": 3809,
            "Pacific Islander: Saipanese": 514,
            "Pacific Islander: Yapese": 1321,
            "Pacific Islander: Fijian": 36285,
            "Pacific Islander: Papua New Guinean": 568,
            "Pacific Islander: Solomon Islander": 96,
            "Pacific Islander: Ni-Vanuatu": 101,
            "Pacific Islander: New Caledonian": 91
        },
        "Some Other Race": {
            "Aruban": 388,
            "Belizean": 11311,
            "Bermudan": 563,
            "Brazilian": 145180,
            "Cabo Verdean": 29507,
            "Comorian": 77,
            "Cayman Islander": 303,
            "Guyanese": 70592,
            "Mauritanian": 1013,
            "Surinamese": 825
        },
        "Hispanic or Latino": {
            "Hispanic or Latino": 2067702,
            "Hispanic or Latino: Mexican": 35850702,
            "Hispanic or Latino: Central American": 5907332,
            "Hispanic or Latino: Costa Rican": 167940,
            "Hispanic or Latino: Guatemalan": 1669557,
            "Hispanic or Latino: Honduran": 1061585,
            "Hispanic or Latino: Nicaraguan": 406613,
            "Hispanic or Latino: Panamanian": 215633,
            "Hispanic or Latino: Salvadoran": 2342001,
            "Hispanic or Latino: South American": 4048060,
            "Hispanic or Latino: Argentinean": 276081,
            "Hispanic or Latino: Bolivian": 123257,
            "Hispanic or Latino: Chilean": 168235,
            "Hispanic or Latino: Colombian": 1286662,
            "Hispanic or Latino: Ecuadorian": 775529,
            "Hispanic or Latino: Paraguayan": 26079,
            "Hispanic or Latino: Peruvian": 685730,
            "Hispanic or Latino: Uruguayan": 64394,
            "Hispanic or Latino: Venezuelan": 605381,
            "Hispanic or Latino: Caribbean Hispanic": 10049681,
            "Hispanic or Latino: Cuban": 2245686,
            "Hispanic or Latino: Dominican": 2196076,
            "Hispanic or Latino: Puerto Rican": 5601863,
            "Hispanic or Latino: Spaniard": 978978,
            "Hispanic or Latino: Spanish": 866356,
        }
    },
    "hispanic_suffixes": {
        "with Mexican ethnicity": 35850702,
        "with Central American heritage": 5907332,
        "with Costa Rican ethnicity": 167940,
        "with Guatemalan ethnicity": 1669557,
        "with Honduran ethnicity": 1061585,
        "with Nicaraguan ethnicity": 406613,
        "with Panamanian ethnicity": 215633,
        "with Salvadoran ethnicity": 2342001,
        "with South American heritage": 4048060,
        "with Argentinean ethnicity": 276081,
        "with Bolivian ethnicity": 123257,
        "with Chilean ethnicity": 168235,
        "with Colombian ethnicity": 1286662,
        "with Ecuadorian ethnicity": 775529,
        "with Paraguayan ethnicity": 26079,
        "with Peruvian ethnicity": 685730,
        "with Uruguayan ethnicity": 64394,
        "with Venezuelan ethnicity": 605381,
        "with Caribbean heritage": 10049681,
        "with Cuban ethnicity": 2245686,
        "with Dominican ethnicity": 2196076,
        "with Puerto Rican ethnicity": 5601863,
        "and Spaniard": 978978,
        "with Spanish heritage": 866356,
        "and Hispanic": 1738931,
        "and Latino(a)": 328771
    }
}